import { RouteConfig } from 'vue-router'
import { remindersRouteNames } from '@/routes/constants/location'

const RemindersPage = () =>
  import(
    /* webpackChunkName: "reminders" */ '@/pmd/pages/RemindersPage.vue'
  ).then(m => m.default)

export const remindersRoute: RouteConfig[] = [
  {
    path: 'reminders',
    name: remindersRouteNames.default,
    component: RemindersPage,
  },
]
